import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50303552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "display-4" }, "Upload your creation", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "mt-3 d-flex" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md mt-3 mt-md-0" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], { title: "Upload creation" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["VForm"], {
              class: "card-body",
              form: $setup.form
            }, {
              default: _withCtx(() => [
                _createVNode($setup["VField"], {
                  name: "title",
                  "show-error": false
                }),
                _createVNode($setup["VField"], {
                  class: "mt-3",
                  name: "body",
                  is: "textarea",
                  initialHeight: 200
                }),
                _createVNode($setup["VError"], { class: "d-block" }),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex-grow-1 file-input", {disabled: !!$setup.preselectedFile}])
                  }, [
                    _createElementVNode("div", {
                      class: "input-group",
                      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($setup.fileInputEl?.click()), ["prevent"]))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["btn btn-primary", {disabled: !!$setup.preselectedFile}])
                      }, "Select file", 2),
                      _createElementVNode("input", {
                        class: "form-control",
                        type: "text",
                        value: $setup.selectedFile ? $setup.selectedFile.name : $setup.preselectedFile ? $setup.preselectedFile.fileName : '',
                        placeholder: "No file selected"
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInputEl",
                      onChange: $setup.fileSelected
                    }, null, 544)
                  ], 2),
                  _createVNode($setup["VSubmit"], {
                    class: "ms-3",
                    color: "success"
                  })
                ])
              ]),
              _: 1
            }, 8, ["form"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h5", _hoisted_11, [
                _createTextVNode("Carousel images"),
                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                  _createVNode(_component_icon, {
                    class: "ms-2 info",
                    icon: "info-circle"
                  })
                ])), [
                  [_directive_tooltip, 'These images will be shown at the top of your post. You can reorder them by clicking and dragging.', "left"]
                ])
              ]),
              _hoisted_12,
              _createVNode($setup["ImageUploader"], {
                class: "flex-wrap",
                modelValue: $setup.images,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.images) = $event)),
                reorderable: "reorderable",
                showNotAddedWarning: false,
                showNoImagesWarning: "showNoImagesWarning"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}